import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, HandleSideMenuWithAuth, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { BaseMember } from './../base-member';

@Component({
    selector: 'app-member-list',
    templateUrl: './member-list.component.html',
    styleUrls: ['./member-list.component.css'],
    providers: [
        MemberService,
        MessageEvent,
        SignInEvent,
        OpenFrameEvent,
        LoaderEvent,
        SidemenuSubCategory,
        HiddenFooter,
        SetAllMemberCheck,
        HandleSideMenuWithAuth
    ]
})
export class MemberListComponent extends BaseMember implements OnInit {
    private shouldSlide: boolean = false;
    private hideEdit: boolean;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 20;
    private height: any;
    private scrollOptions: ISlimScrollOptions;
    private divHeight = 30;
    private member: any = {
        'vendorId': '',
        'members': []
    };
    private showFilterPreference = false;
    private selectItem = false;
    private noMemberAvailableInFilter = false
    @ViewChild('fileUploadInput')
    fileUploadInputVariable: any;
    @ViewChild('searchInput')
    searchInputVariable: any;
    private exp;
    private totalSizeOfList = 0;
    private onePagePerItem = 10; // It will set by vendor configuration object
    private filterPara = '';
    private pageOptions = {
        currentPage: 1,
        noOfPageItem: this.onePagePerItem
    };
    private message = '';
    private clubName = '';
    private showFilterGroup = false;
    @ViewChild('memberTable')
    tableVariable: any;

    constructor(private router: Router, private memberService: MemberService, private appService: AppService,
        private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter,private handleSideMenuWithAuth :  HandleSideMenuWithAuth) {
        super();
        this.popUpMessage = 'Is Payment Done';
        this.hideEdit = false;
       this.scrollOptions = {
           barBackground: "#343a40", barOpacity: "0.6", position: "right",
           barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        };
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
        this.exp = false;
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }

    ngOnInit() {
        let obj = {
            category: 'All Members',
            menu: 'Members'
        };
        this.sidemenuSubCategory.fire(obj);


        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        // Temporary Fixed issue for sub menu of side menu
        if (this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            this.appService.getFacilityByClub(this.vendor._id);
        } else if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.appService.getFacilityByClub(subVendor._id);
            }
        } else {
            this.appService.getFacilityByClub(this.vendor.vendorId);
        }
        this.getFacilityListForMemberFilter(this);
        this.getGroupListForFilter(this);
        // this.getVendorDetails();
        this.pagination(this.pageOptions, 1);
        this.emitOpenFrameEvent();
        this.emitTypeBroadcast();
        this.registerTypeBroadcast();
                if (localStorage.getItem('Wizard')) {
            let wizard = JSON.parse(atob(localStorage.getItem('Wizard')));
            if (wizard == 'Done') {
                this.handleSideMenuWithAuth.fire({ fire: 'on', role: this.vendor.role });
                this.vendor.isFirstTimeLogin = false;
            }
        }
    }

    /**
     * Fetch MemberList with respect to condo
     */

    getMemberListByVendor(vendorObj) {
        this.loaderEvent.fire(false);
        let that = this;
        this.appService.getListOfMember(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.memberList = result.memberList;
                this.totalSizeOfList = result.total;
                this.noMemberAvailable = (result.total > 0);
                this.memberList.map(function (mem) {
                    if (!mem.isBlackListed) {
                        mem.enable = 'Active';
                    } else {
                        mem.enable = 'Inactive';
                    }

                    mem.signedUpOn =  that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
                    return mem;
                });
                if (this.memberList.length === 0) {
                    this.noMemberAvailable = false;
                } else {
                    this.noMemberAvailable = true;
                }
                if (vendorObj['filters'].length > 0) {
                    this.noMemberAvailableInFilter = true;
                } else {
                    this.noMemberAvailableInFilter = false;
                }
            }
            that.loaderEvent.fire(true);

        })
            .catch((err) => {
                this.popUpMessage = err;
                this.loaderEvent.fire(true);
            });

    }

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster
     */

    registerTypeBroadcast() {
        this.messageEvent.on().subscribe(message => {
            this.shouldSlide = message;
        });
    }

    /**
     * Upload only csv file
     * sequence is emailId, contactNumber, membershipId
     */

    uploadFile(event, popUpObj) {
        this.loaderEvent.fire(false);
        let input = event.target;
        let file = input.files[0];
        let that = this;
        if (file.name.indexOf('.csv') !== -1) {
            this.memberService.getMembersFromFile(input).then((members) => {
                this.resetFileUploadInput();
                that.member.members = members;
                if (this.member.members.length > 0) {
                    this.member.vendorId = this.vendor._id;
                    this.memberService.addMember(this.member).then((result: any) => {
                        if (result.status === 'SUCCESS') { } else { }
                        this.popUpMessage = result.message;
                        popUpObj.showChildModal();
                        this.loaderEvent.fire(true);
                    });
                }
                this.loaderEvent.fire(true);
            });
        } else {
            this.loaderEvent.fire(true);
            this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
            popUpObj.showChildModal();
        }
    }

    onNotify() {
        this.router.navigate(['/']);
    }

    resetFileUploadInput() {
        this.fileUploadInputVariable.nativeElement.value = '';
    }

    /**
    * Search element will expand on search icon
    */

    expand() {
        if ((this.searchMember + '').trim()) {
            this.pagination(this.pageOptions, 1);
        } else {
            this.searchMember = '';
            if (this.exp) {
                this.pagination(this.pageOptions, 1);
            }
            this.exp = !this.exp;
        }
    }
    /**
    * Go to add member page
    */
    redirectToAddMember() {
        if (localStorage.getItem('vendor')) {
            this.router.navigate(['/addmember']);
        }
    }
    /**
    * Go to create group page
    */
    redirectToCreateGroup() {
        if (localStorage.getItem('vendor')) {
            this.router.navigate(['/creategroup']);
        }
    }
    /**
    * Get vendor details
    */
    getVendorDetails() {
        try {
            let obj = {
                vendorId: this.vendor._id
            };
            this.memberService.getVendorDetails(obj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this.vendor = result.vendor[0];
                } else { }
            });
        } catch (err) { }
    }
    /**
     * Set filter , search and pagination to get member list
     *
     * @param {any} pageOptions
     * @param {any} pageNo
     *
     * @memberof MemberListComponent
     */
    pagination(pageOptions, pageNo) {
        this.filterState = this.filterPara;
        if (pageOptions) {
            this.pageOptions = pageOptions;
        }
        // staff can not see all members
        let vendorObject = this.setVendorIdAsPerRole(this, pageNo);
        this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED_MESSAGE;
        this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
        switch (this.filterPara) {
            case 'Inactive':
                vendorObject['filters'].push({
                    type: 'isDeactivated',
                    values: true
                });
                this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
                break;
            case 'DisabledFacility':
                vendorObject['filters'].push({
                    type: 'disabled',
                    values: this.facilityFilter,
                    applyAll: false
                });
                this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
                this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
                break;
            case 'Prefernces':
                vendorObject['filters'].push({
                    type: 'facilityPreference',
                    values: this.preferenceFilter,
                    applyAll: false
                });
                this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
                this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
                break;
            case 'Groups':
                vendorObject['filters'].push({
                    type: 'group',
                    values: this.groupFilter,
                    applyAll: false
                });
                this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
                this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
                break;
        }
        if ((this.searchMember + '').trim()) {
            vendorObject['filters'].push({
                type: 'search',
                values: this.searchMember
            });
            this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        }
        this.getMemberListByVendor(vendorObject);
    }
    /**
         * Add facility in list to filter by disable facility
         */
    addFacilityForFilter(e, facilityId) {
        this.utilityFunctions.addFacilityForFilter(this, e, facilityId);
    }
    /**
         * Add group in list to filter by group
         */
    addGroupForFilter(e, groupId) {
        this.utilityFunctions.addGroupForFilter(this, e, groupId);
    }
    /**
         * Add facility in list to filter by preference
         */
    addPreferencesForFilter(e, facilityId) {
        this.utilityFunctions.addPreferencesForFilter(this, e, facilityId);
    }
    /**
         * Select filter criteria
         */
    setFilterCriteria(para) {
        this.utilityFunctions.setFilterCriteria(this, para);
    }
    /**
         * Maintain filter state
         */
    maintainFilterState() {
        this.utilityFunctions.maintainFilterState(this);
    }
}



// WEBPACK FOOTER //
// ./src/app/member/member-list/member-list.component.ts